import { FC, ReactNode, useRef } from 'react';
import { useOutsideClick } from '../../hooks/useOutsideClick';

export interface OutsideClickHandlerProps {
  children: ReactNode;
  onOutsideClick: (event: MouseEvent | TouchEvent) => void;
  disabled?: boolean;
}

const OutsideClickHandler: FC<OutsideClickHandlerProps> = ({
  children,
  onOutsideClick,
  disabled = false,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useOutsideClick(ref, disabled ? () => {} : onOutsideClick);

  return <div ref={ref}>{children}</div>;
};

export default OutsideClickHandler;
